var React = require('react');

function Swoop0 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M292 291.667V0C130.737 0 0 130.587 0 291.667V583.333V680.556V705.9V875C161.007 875 292 744.156 292 583.333V437.509V291.667Z","fill":"currentColor"}));
}

Swoop0.defaultProps = {"width":"292","height":"875","viewBox":"0 0 292 875","fill":"none"};

module.exports = Swoop0;

Swoop0.default = Swoop0;
